import { render, staticRenderFns } from "./UserTrendLandingTable.vue?vue&type=template&id=71255811&scoped=true"
import script from "./UserTrendLandingTable.vue?vue&type=script&lang=ts"
export * from "./UserTrendLandingTable.vue?vue&type=script&lang=ts"
import style0 from "./UserTrendLandingTable.vue?vue&type=style&index=0&id=71255811&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71255811",
  null
  
)

export default component.exports